import Header from "../../components/Header"
import { NavLink, Outlet } from "react-router-dom"

const NavigationItem: React.FC<{ to?: string, title: string }> = ({ to = "/", title }) => {
    return <NavLink end className={({ isActive }) => `rounded-t-lg ${isActive ? "text-zinc-700 bg-white" : "bg-transparent text-white"} px-5 py-2`} to={to}>{title}</NavLink>
}

const HomeNavigation = () => {
    return (
        <div className="px-5 md:px-32 flex items-center gap-5 bg-[#c63631] overflow-x-auto">
            <NavigationItem to={`/`} title="Jugadores" />
            <NavigationItem to={`/teams`} title="Equipos" />
        </div>
    )
}

const HomePage = () => {
    return (
        <div>
            <Header className="flex flex-col gap-5 bg-[#c63631]">
                <p className="text-white font-extrabold uppercase text-4xl">Inicio</p>
            </Header>
            <HomeNavigation />

            <Outlet />
        </div>
    )
}

export default HomePage